import { useEffect, useState } from 'react'
import { api } from '../api/client'
import Aviso from '../components/Aviso'
import { competenciaAtual, pct } from '../components/format'

const REGIMES = [
  ['SIMPLES_NACIONAL_GERAL', 'Simples Nacional (Anexos I a III e V)'],
  ['SIMPLES_NACIONAL_ANEXO_IV', 'Simples Nacional (Anexo IV)'],
  ['LUCRO_PRESUMIDO', 'Lucro Presumido'],
  ['LUCRO_REAL', 'Lucro Real'],
  ['IMUNE_ISENTA', 'Imune / Isenta'],
]
const COM_CPRB = ['LUCRO_PRESUMIDO', 'LUCRO_REAL']
const VAZIO = {
  regime_tributario: 'LUCRO_PRESUMIDO',
  ind_desoneracao_cprb: false,
  codigo_fpas: '',
  codigo_terceiros: '',
  aliquota_rat_base: '1.00',
  fator_fap: '1.0000',
}
const NOMES_ENCARGO = { inss_patronal: 'INSS patronal', rat: 'RAT (ajustado)', terceiros: 'Terceiros', fgts: 'FGTS' }

export default function TributacaoEmpresa({ empresaId }) {
  const [form, setForm] = useState(VAZIO)
  const [calculado, setCalculado] = useState(null)
  const [matriz, setMatriz] = useState(null)
  const [erro, setErro] = useState('')
  const [ok, setOk] = useState('')
  const [salvando, setSalvando] = useState(false)

  useEffect(() => {
    if (!empresaId) return
    setErro('')
    setOk('')
    api
      .obterTributacao(empresaId)
      .then((dados) => {
        setForm(Object.fromEntries(Object.keys(VAZIO).map((k) => [k, dados[k]])))
        setCalculado(dados)
        return api.obterEncargos(empresaId, competenciaAtual()).then(setMatriz)
      })
      .catch(() => {
        setForm(VAZIO)
        setCalculado(null)
        setMatriz(null)
      })
  }, [empresaId])

  const set = (campo) => (e) => {
    const valor = e.target.type === 'checkbox' ? e.target.checked : e.target.value
    setForm((f) => {
      const novo = { ...f, [campo]: valor }
      if (campo === 'regime_tributario' && !COM_CPRB.includes(valor)) novo.ind_desoneracao_cprb = false
      return novo
    })
  }

  async function salvar(e) {
    e.preventDefault()
    setSalvando(true)
    setErro('')
    setOk('')
    try {
      const dados = await api.salvarTributacao(empresaId, form)
      setCalculado(dados)
      setMatriz(await api.obterEncargos(empresaId, competenciaAtual()))
      setOk('Parametrização salva.')
    } catch (err) {
      setErro(err.message)
    } finally {
      setSalvando(false)
    }
  }

  return (
    <section>
      <h2>Parametrização tributária</h2>
      <form className="grade" onSubmit={salvar}>
        <label>
          Regime tributário
          <select value={form.regime_tributario} onChange={set('regime_tributario')}>
            {REGIMES.map(([v, l]) => (
              <option key={v} value={v}>{l}</option>
            ))}
          </select>
        </label>
        <label className="check">
          <input
            type="checkbox"
            checked={form.ind_desoneracao_cprb}
            disabled={!COM_CPRB.includes(form.regime_tributario)}
            onChange={set('ind_desoneracao_cprb')}
          />
          Desoneração da folha (CPRB)
        </label>
        <label>
          Código FPAS
          <input value={form.codigo_fpas} onChange={set('codigo_fpas')} pattern="\d{3}" placeholder="507" required />
        </label>
        <label>
          Código de terceiros
          <input value={form.codigo_terceiros} onChange={set('codigo_terceiros')} pattern="\d{4}" placeholder="0079" required />
        </label>
        <label>
          Alíquota RAT base
          <select value={form.aliquota_rat_base} onChange={set('aliquota_rat_base')}>
            {['1.00', '2.00', '3.00'].map((v) => (
              <option key={v} value={v}>{pct(v)}</option>
            ))}
          </select>
        </label>
        <label>
          Fator FAP
          <input type="number" step="0.0001" min="0.5" max="2" value={form.fator_fap} onChange={set('fator_fap')} required />
        </label>
        <div className="acoes">
          <button disabled={salvando || !empresaId}>{salvando ? 'Salvando…' : 'Salvar'}</button>
        </div>
      </form>
      <Aviso>{erro}</Aviso>
      <Aviso tipo="ok">{ok}</Aviso>

      {calculado && (
        <div className="cards">
          <div className="card">
            <span>Alíquota de terceiros calculada</span>
            <strong>{pct(calculado.aliquota_terceiros_calculada)}</strong>
            <small>{calculado.terceiros_entidades.join(', ') || 'Nenhuma entidade'}</small>
          </div>
          <div className="card">
            <span>RAT ajustado (RAT × FAP)</span>
            <strong>{pct(calculado.aliquota_rat_ajustado, 4)}</strong>
            <small>Parâmetros {calculado.parametros_versao}</small>
          </div>
        </div>
      )}

      {matriz && (
        <>
          <h3>Encargos aplicáveis ({matriz.competencia})</h3>
          <p className="fundamento">{matriz.fundamento}</p>
          <table>
            <thead>
              <tr><th>Encargo</th><th>Situação</th><th>Alíquota</th><th>Regra</th></tr>
            </thead>
            <tbody>
              {matriz.encargos.map((e) => (
                <tr key={e.encargo}>
                  <td>{NOMES_ENCARGO[e.encargo]}</td>
                  <td>{e.devido ? 'Devido' : 'Isento'}</td>
                  <td className="num">{pct(e.aliquota, e.encargo === 'rat' ? 4 : 2)}</td>
                  <td>{e.regra}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </section>
  )
}
